export default "<!-- Revert to the standard avator -->\r\n<dw-security-avatar></dw-security-avatar>";